import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaProductos from './TablaProductos';

const Productos: React.FC = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <TablaProductos />
    </Box>
  );
};

export default Productos;
